import { useTranslation } from "react-i18next";
import AlertDefault, { AlertVariant } from "~/src/components/Alerts/AlertDefault";
import BottomLine from "~/src/components/BottomLine";
import Checkbox from "~/src/components/Form/Checkbox";

type VelgTerrengProps = {
  innmark: boolean;
  utmark: boolean;
  setInnmark: (value: boolean) => void;
  setUtmark: (value: boolean) => void;
  errors: boolean;
};

const VelgTerreng = ({ innmark, utmark, setInnmark, setUtmark, errors }: VelgTerrengProps) => {
  const { t } = useTranslation();

  return (
    <fieldset className="mt-4 flex flex-col gap-4">
      <legend className="text-xl">{t("pages.registrerArt.hjort.velgTerreng")}</legend>
      <AlertDefault
        variant={errors && !innmark && !utmark ? AlertVariant.Error : AlertVariant.Info}
      >
        {t("pages.registrerArt.hjort.terrengHelpMessage")}
      </AlertDefault>
      <div>
        <div className="flex-col flex bg-ldir-gray-600">
          <BottomLine />
          <Checkbox
            value="innmark"
            label={t("pages.fellingsinfo.innmark")}
            checked={!!innmark}
            onChange={(e) => {
              setInnmark(Boolean(e.target.checked));
            }}
          />
          <BottomLine />
          <Checkbox
            value="utmark"
            label={t("pages.fellingsinfo.utmark")}
            checked={!!utmark}
            onChange={(e) => {
              setUtmark(Boolean(e.target.checked));
            }}
          />
        </div>
        <BottomLine />
      </div>
    </fieldset>
  );
};

export default VelgTerreng;
